(function () {
  'use strict';

  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';
  var productCache = {};

  function productUrl(handle) {
    return root + 'products/' + handle;
  }

  function collectionUrl(handle) {
    return root + 'collections/' + handle;
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('da-DK', {
      style: 'currency',
      currency: 'DKK',
      minimumFractionDigits: 2
    }).format((parseInt(cents || '0', 10)) / 100);
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch(productUrl(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }
    return productCache[handle];
  }

  function isAvailable(product) {
    if (!product || product.available === false) return false;
    return Array.isArray(product.variants)
      ? product.variants.some(function (variant) { return variant.available !== false; })
      : product.available === true;
  }

  function firstAvailable(handles) {
    return Promise.all(handles.map(fetchProduct)).then(function (products) {
      return products.find(isAvailable) || null;
    });
  }

  function unique(items) {
    return items.filter(function (item, index) {
      return item && items.indexOf(item) === index;
    });
  }

  function heroCopy(handle) {
    switch (handle) {
      case 'double-sided-whetstone-1000-5000':
        return {
          button: 'Se Grundstenen',
          proof: 'Til slibning med kontrol',
          caption: 'Korn 1000 til slibning · 5000 til en finere æg'
        };
      case 'double-sided-whetstone-3000-8000':
        return {
          button: 'Se Polérstenen',
          proof: 'Til den fine afslutning',
          caption: 'Korn 3000 og 8000 til finpudsning og polering'
        };
      case 'magnetic-knife-holder-acacia-19-6':
        return {
          button: 'Se knivlisten',
          proof: 'På lager til opbevaring',
          caption: '50 cm magnetisk knivlist i akacietræ'
        };
      default:
        return {
          button: 'Se knivsliberen',
          proof: 'Til hurtig vedligeholdelse',
          caption: 'Grov, fin og polér i ét redskab'
        };
    }
  }

  function updateHeroProduct(section, product) {
    if (!section || !product) return;

    var url = productUrl(product.handle);
    var copy = heroCopy(product.handle);
    var primary = section.querySelector('[data-ln-event="hero_primary"]');
    var proof = section.querySelector('.ln10-hero__product-proof');
    var mediaLink = section.querySelector('.ln10-hero__main-image');
    var mediaImage = section.querySelector('.ln10-hero__image');
    var caption = section.querySelector('.ln10-hero__image-caption');

    if (primary) {
      primary.href = url;
      primary.dataset.lnProduct = product.handle;
      primary.textContent = copy.button + ' · ' + formatMoney(product.price);
    }

    if (proof) {
      var proofLabel = proof.querySelector(':scope > span');
      var proofLink = proof.querySelector('a');
      var proofTitle = proof.querySelector('strong');
      var proofPrice = proof.querySelector('small');

      if (proofLabel) proofLabel.textContent = copy.proof;
      if (proofLink) {
        proofLink.href = url;
        proofLink.dataset.lnProduct = product.handle;
      }
      if (proofTitle) proofTitle.textContent = product.title;
      if (proofPrice) proofPrice.textContent = formatMoney(product.price) + ' · På lager';
    }

    if (mediaLink) {
      mediaLink.href = url;
      mediaLink.dataset.lnProduct = product.handle;
    }

    if (mediaImage && product.featured_image) {
      mediaImage.src = product.featured_image;
      mediaImage.removeAttribute('srcset');
      mediaImage.alt = product.title;
    }

    if (caption) caption.textContent = copy.caption;

    document.dispatchEvent(new CustomEvent('ln:event', {
      detail: {
        event: 'inventory_routing',
        placement: 'homepage_hero',
        product: product.handle
      }
    }));
  }

  function updateHeroFallback(section) {
    if (!section) return;
    var url = collectionUrl('the-ritual-set');
    var primary = section.querySelector('[data-ln-event="hero_primary"]');
    var proof = section.querySelector('.ln10-hero__product-proof');
    var mediaLink = section.querySelector('.ln10-hero__main-image');
    var caption = section.querySelector('.ln10-hero__image-caption');

    if (primary) {
      primary.href = url;
      primary.removeAttribute('data-ln-product');
      primary.textContent = 'Se slibning og pleje';
    }
    if (proof) {
      var proofLabel = proof.querySelector(':scope > span');
      var proofLink = proof.querySelector('a');
      var proofTitle = proof.querySelector('strong');
      var proofPrice = proof.querySelector('small');
      if (proofLabel) proofLabel.textContent = 'Se det, der er på lager';
      if (proofLink) {
        proofLink.href = url;
        proofLink.removeAttribute('data-ln-product');
      }
      if (proofTitle) proofTitle.textContent = 'Slibesten, knivslibere og pleje';
      if (proofPrice) proofPrice.textContent = 'Se aktuel lagerstatus';
    }
    if (mediaLink) {
      mediaLink.href = url;
      mediaLink.removeAttribute('data-ln-product');
    }
    if (caption) caption.textContent = 'Slibning og pleje til forskellige behov';
  }

  function initHeroRouting() {
    var section = document.querySelector('.ln10-hero');
    if (!section) return;

    var current = section.querySelector('[data-ln-event="hero_primary"]');
    var currentHandle = current ? current.dataset.lnProduct : '';
    var handles = unique([
      currentHandle,
      'walnut-sharpener-xz-mdq01-htm',
      'ash-wood-sharpener-xz-mdq01-blm',
      'double-sided-whetstone-1000-5000',
      'magnetic-knife-holder-acacia-19-6',
      'double-sided-whetstone-3000-8000'
    ]);

    firstAvailable(handles).then(function (product) {
      if (product) updateHeroProduct(section, product);
      else updateHeroFallback(section);
    });
  }

  function setFinderCard(card, product, fallbackTitle, fallbackBody) {
    if (!card) return;

    var heading = card.querySelector('h3');
    var body = card.querySelector('p:not(.ln10-finder__price)');
    var price = card.querySelector('.ln10-finder__price');
    var link = card.querySelector('a.ln10-button');

    if (product) {
      if (heading) heading.textContent = product.title;
      if (price) price.textContent = formatMoney(product.price) + ' · På lager';
      if (link) {
        link.href = productUrl(product.handle);
        link.dataset.lnEvent = 'finder_product_click';
        link.dataset.lnProduct = product.handle;
        link.textContent = 'Se anbefalingen';
      }
      return;
    }

    if (heading) heading.textContent = fallbackTitle;
    if (body) body.textContent = fallbackBody;
    if (price) price.remove();
    if (link) {
      link.href = collectionUrl('the-ritual-set');
      link.dataset.lnEvent = 'finder_collection_click';
      link.removeAttribute('data-ln-product');
      link.textContent = 'Se løsninger på lager';
    }
  }

  function addQuickStockNote(form) {
    if (!form || form.querySelector('[data-ln-quick-stock-note]')) return;
    var input = form.querySelector('input[name="method"][value="quick"]');
    var text = input && input.closest('label') ? input.closest('label').querySelector('span') : null;
    if (!text) return;

    var note = document.createElement('small');
    note.dataset.lnQuickStockNote = 'true';
    note.textContent = 'Knivsliberne er midlertidigt udsolgt. Du får et ærligt alternativ i resultatet.';
    note.style.display = 'block';
    note.style.marginTop = '0.45rem';
    note.style.color = 'rgba(247, 244, 239, 0.92)';
    note.style.fontSize = '0.75rem';
    text.appendChild(note);
  }

  function initFinderRouting() {
    var form = document.querySelector('[data-ln-finder]');
    if (!form) return;

    Promise.all([
      firstAvailable([
        'walnut-sharpener-xz-mdq01-htm',
        'ash-wood-sharpener-xz-mdq01-blm'
      ]),
      firstAvailable(['double-sided-whetstone-1000-5000']),
      firstAvailable(['double-sided-whetstone-3000-8000'])
    ]).then(function (products) {
      var quick = products[0];
      var foundation = products[1];
      var polish = products[2];

      if (!quick) addQuickStockNote(form);

      setFinderCard(
        document.querySelector('[data-ln-result="quick"]'),
        quick,
        'Den hurtige knivsliber er midlertidigt udsolgt',
        'Vi sender dig ikke videre til en vare, du ikke kan købe. Se de aktuelle slibesten og knivslibere, og vælg efter den teknik, du vil bruge.'
      );
      setFinderCard(
        document.querySelector('[data-ln-result="foundation"]'),
        foundation,
        'Grundstenen er midlertidigt udsolgt',
        'Se de aktuelle produkter til slibning og pleje. Lagerstatus og pris kommer direkte fra Shopify.'
      );
      setFinderCard(
        document.querySelector('[data-ln-result="polish"]'),
        polish,
        'Polérstenen er midlertidigt udsolgt',
        'Se de aktuelle produkter til slibning og pleje. Lagerstatus og pris kommer direkte fra Shopify.'
      );
    });
  }

  function init() {
    initHeroRouting();
    initFinderRouting();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();